<template>
  <v-container fluid>
    <reporting-no-campaigns-placeholder
      v-if="!campaigns.length"
    />
    <reporting-no-data-placeholder
      v-else-if="!insights.length"
      :initialDates="dates"
      :pickerOptions="pickerOptions"
      @setDate="setReportingDates"
    />
    <v-row class="ma-0" v-else>
      <v-col cols="12">
        <h1>Messages
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" color="blue-grey lighten-1" style="vertical-align:text-top; margin-top:3px">info</v-icon>
            </template>
            <span>Which messages are resonating the most for this campaign?</span>
          </v-tooltip>
        </h1>
      </v-col>
      <v-col cols="12">
        <v-row class="ma-0">
          <v-spacer />
          <the-date-picker
            v-if="dates.length >= 2"
            :initialDates="dates"
            :pickerOptions="pickerOptions"
            @setDate="setReportingDates"
          />
        </v-row>
      </v-col>
      <v-col cols="12">
        <div class="campaign-select__card">
          <h3>Select a campaign or ad group to dig in deeper</h3>
          <message-reporting-item-selector
            :campaigns="campaigns"
            :selectedCampaign="selectedCampaign"
            :selectedIssue="selectedIssue"
            @setCampaignId="setCampaignId"
            @setIssueId="setIssueId"
          />
        </div>
      </v-col>
      <v-col cols="12">
        <v-row align="center">
          <v-col cols="12" sm="6" md="4">
            <v-select
              :items="leftChartOptions"
              label="Select"
              v-model="selectedLeft"
              item-text="name"
              item-value="value"
              single-line
              class="select-bordered"
            />
          </v-col>
          <v-spacer />
          <v-col cols="12" sm="6" md="4">
            <v-select
              :items="rightChartOptions"
              label="Select"
              v-model="selectedRight"
              item-text="name"
              item-value="value"
              single-line
              class="select-bordered"
            />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <horizontal-double-bar-chart
          :leftChartData="leftChartData"
          :rightChartData="rightChartData"
          :leftMetric="selectedLeft"
          :rightMetric="selectedRight"
        />
      </v-col>
      <v-col cols="12">
        <v-card text>
          <v-card-title>
            <v-spacer />
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            />
          </v-card-title>
          <reports-insights-data-table
            :insights="insights"
            :firstColumn="{text: 'Message', value: 'ad_name'}"
            :campaignTypeColumn="false"
            :search="search"
          />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TheDatePicker from '../../helpers/TheDatePicker.vue'
import MessageReportingItemSelector from './MessageReportItemSelector'
import HorizontalDoubleBarChart from '../../charts/HorizontalDoubleBarChart'
import ReportsInsightsDataTable from '../commonUI/ReportsInsightsDataTable'
import ReportingNoCampaignsPlaceholder from '../commonUI/ReportingNoCampaignsPlaceholder'
import ReportingNoDataPlaceholder from '../commonUI/ReportingNoDataPlaceholder'
import helpers from '../../../helpers/functions'
export default {
  name: 'messages-reporting',
  components: {
    TheDatePicker,
    MessageReportingItemSelector,
    HorizontalDoubleBarChart,
    ReportsInsightsDataTable,
    ReportingNoCampaignsPlaceholder,
    ReportingNoDataPlaceholder
  },
  data () {
    return {
      leftChartOptions: [
        {
          name: 'Reach',
          value: 'reach'
        },
        {
          name: 'Budget spent',
          value: 'spend'
        }
      ],
      rightChartOptions: [
        {
          name: 'Cost per Click',
          value: 'cpc'
        },
        {
          name: 'Cost per Action',
          value: 'cpa'
        }
      ],
      selectedLeft: 'reach',
      selectedRight: 'cpc',
      selectedCampaign: null,
      selectedIssue: null,
      search: ''
    }
  },
  props: {
    dates: {
      type: Array,
      default: () => []
    },
    pickerOptions: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    pages () {
      if (this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      ) return 0
      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
    },
    campaigns () {
      return this.$store.getters.getCampaigns
    },
    insights () {
      const insights = this.$store.getters.getAdsInsights
      if (this.selectedIssue) {
        const filteredInsights = insights.filter(i => i.adset_id === this.selectedIssue)
        return helpers.sortArrayofObjectes([...filteredInsights], 'spend')
      } else if (this.selectedCampaign) {
        const filteredInsights = insights.filter(i => i.campaign_id === this.selectedCampaign)
        return helpers.sortArrayofObjectes([...filteredInsights], 'spend')
      }
      return helpers.sortArrayofObjectes([...insights], 'spend')
    },
    leftChartData () {
      const metrics = this.insights.map(c => c.ad_name)
      const data = []
      this.insights.forEach(insight => {
        const value = isNaN(insight[this.selectedLeft]) ? 0 : Number(insight[this.selectedLeft])
        data.push(value)
      })
      return {metrics, data}
    },
    rightChartData () {
      const metrics = this.insights.map(c => c.ad_name)
      const data = []
      this.insights.forEach(insight => {
        const value = isNaN(insight[this.selectedRight]) ? 0 : Number(insight[this.selectedRight])
        data.push(value)
      })
      return {metrics, data}
    }
  },
  methods: {
    setReportingDates (dates) {
      this.$store.commit('helpers/SET_REPORTING_DATES', dates)
      this.$emit('updateInsights')
    },
    setIssueId (id) {
      this.selectedIssue = id
    },
    setCampaignId (id) {
      this.selectedIssue = null
      this.selectedCampaign = id
    }
  }
}
</script>
